export enum FormResponseNotificationSetting {
  none = "NONE",
  system = "SYSTEM"
}
